import { render } from "./Videos.vue?vue&type=template&id=124197ce&scoped=true&ts=true"
import script from "./Videos.vue?vue&type=script&lang=ts"
export * from "./Videos.vue?vue&type=script&lang=ts"

import "./Videos.vue?vue&type=style&index=0&id=124197ce&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124197ce"]])

export default __exports__